import { useDispatch } from "react-redux"
import { AppDispatch } from "../components/store"

const useAppDispatch = () => useDispatch<AppDispatch>()
export default useAppDispatch
